import type { SvgComponent } from '../SvgComponent';
import ProfilePicture_svg from './ProfilePicture.svg';

export const IconProfilePicture = ProfilePicture_svg as SvgComponent;
